import * as React from "react"

const SvgArrowDownMini = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 16 16"
    {...props}
  >
    <path d="M7.5 10.18V3q0-.425.288-.713A.97.97 0 0 1 8.5 2q.424 0 .713.287.287.288.287.713v7.18l2.9-2.9a.95.95 0 0 1 .7-.275.95.95 0 0 1 .7.275.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7l-4.6 4.6q-.3.3-.7.3a.96.96 0 0 1-.7-.3l-4.6-4.6a.95.95 0 0 1-.275-.7.95.95 0 0 1 .275-.7.95.95 0 0 1 .7-.275.95.95 0 0 1 .7.275z" />
  </svg>
)
export default SvgArrowDownMini
